import gql from 'graphql-tag';

export default gql`
  mutation UpdatePreferredStore($storeNumber: String!){
    updatePreferredStore(storeNumber: $storeNumber) {
      storeNumber
    }
  }
`;
